import { Injectable, ErrorHandler } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "@environments/environment";
import { AngularPlugin } from "@microsoft/applicationinsights-angularplugin-js";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";

@Injectable()
export class Insights {
    private angularPlugin = new AngularPlugin();
    
    private appInsights = new ApplicationInsights({
        config: {
            instrumentationKey: environment.AppInsightsInstrumentationKey,
            extensions: [this.angularPlugin],
            extensionConfig: {
                [this.angularPlugin.identifier]: {
                    router: this.router,
                    errorServices: [new ErrorHandler()]
                }
            }
        }
    });

    constructor(private router: Router) {
        this.appInsights.loadAppInsights();
    }

    /**
     * Track the events of what user typed in search input.
     * 
     * @param query What user typed in search input
     */
    trackSearch(query: string):void {
        this.appInsights.trackEvent({name: 'Search', properties:{query: query}});
    }

    trackEvent(name: string): void {
        this.appInsights.trackEvent({ name });
    }

    trackTrace(message: string): void {
        this.appInsights.trackTrace({ message });
    }

}
